<template>
  <div class="tw-flex tw-flex-col tw-gap-4 tw-pb-4 tw-px-6">
    <sf-assistant-check
      v-for="checkId in generalCheckIds"
      :key="checkId"
      :check="checksById[checkId]"
      :read="checkReadStatus[checkId]"
    />
    <template v-for="workflow in hierarchy" :key="workflow.id">
      <template v-for="context in workflow.children" :key="context.id">
        <SfAssistantChecksSectionPanel
          :workflow-id="workflow.id"
          :context-id="context.id"
        />
      </template>
    </template>
  </div>
</template>

<script setup lang="ts">
import { storeToRefs } from 'pinia'

import SfAssistantChecksSectionPanel from './sf-assistant-checks-section-panel.vue'
import SfAssistantCheck from './sf-assistant-check.vue'

import { useSfAssistantChecksPage } from '../stores/page'

const sfAssistantChecksPageStore = useSfAssistantChecksPage()

const { checksById, checkReadStatus, generalCheckIds, hierarchy } = storeToRefs(
  sfAssistantChecksPageStore
)
</script>
